/* eslint-disable */
import lang from 'element-ui/lib/locale/lang/ru-RU'
import DatePicker from './src/picker/date-picker'
/* istanbul ignore next */
DatePicker.install = function install (Vue) {
  Vue.component(DatePicker.name, DatePicker, { locale: lang })
}

export default DatePicker
